import Vue from 'vue'
import clientSubscription from '@/utils/client.subscription'
import sentry from '@/3rd-parties/sentry'

const _state = {
  slideSubmited: {},
}

const _getters = {
  slideSubmited: (state) => {
    return state.slideSubmited
  },
}

const actions = {
  updateSubmitedQuizAction({ commit }, { slideId, status }) {
    commit('updateSubmitedQuiz', { slideId, status })
  },
  async getResulFromAhaSyncAction({
    state, dispatch, commit, rootState,
  }, slideId) {
    if (state.slideSubmited[slideId] === 'waiting') {
      commit('updateSubmitedQuiz', { slideId, status: 'done' })
      const key = `QUIZ_RESULTS/${rootState.audienceId}`
      const value = await dispatch('kvSync/fetchValueByKeyWithoutUpdateAction', {
        key,
      }, {
        root: true,
      })
      if (value) {
        const quizResult = JSON.parse(value)
        const keySubscrible = `${clientSubscription.constantObjectSubcriptionType.submitQuizAnswerType}-${quizResult.slide}`
        if (clientSubscription.objectSubcription[keySubscrible]) {
          if (!quizResult.id) quizResult.id = 1
          clientSubscription.objectSubcription[keySubscrible].resolve(quizResult)
          delete clientSubscription.objectSubcription[keySubscrible] // Sau khi resolve, xóa đi khỏi objectSub (hoặc giữ lại nếu cần)
        }
      } else {
        sentry.captureException('AHA-39885-not-save-answered-when-submit', {
          extra: {
            key,
            slideId,
            slide: rootState.slide,
          },
        })
      }
    }
  },
}

const mutations = {
  updateSubmitedQuiz(state, { slideId, status }) {
    Vue.set(state.slideSubmited, slideId, status)
  },
}

const submitedQuizModule = {
  namespaced: true,
  state: _state,
  getters: _getters,
  actions,
  mutations,
}

export default submitedQuizModule
